import './Toggle.scss';

const Toggle = (props) => {
    return (
        <div className={`v2__toggle-holder ${(props.isOn || props.value === true) ? 'on' : 'off'}`} onClick={props.onToggle}>
            <div className="toggle" />
        </div>
    );
};

export default Toggle;
